export default __webpack_public_path__ + "static/media/5.863ef947.png";